module.exports = __webpack_public_path__ + "static/img/lock_gray.ecd1c4d0.svg";